"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RushOpportunityService_1 = require("../services/RushOpportunityService");
const environment_1 = require("@environment/environment");
angular.module('callX').controller('RushOpportunitiesCtrl', [
    '$scope',
    '$rootScope',
    '$timeout',
    '$interval',
    '$http',
    'toaster',
    function ($scope, $rootScope, $timeout, $interval, $http, toaster) {
        $scope.rushEnabled = RushOpportunityService_1.RushOpportunityService.isEnabled();
        $scope.rushItems = [];
        $scope.rushClaiming = {};
        $scope.rushVisibleCount = 3;
        $scope.rushNowTick = Date.now();
        $scope.phoneReady = false;
        // Poll the telephony SDK login state every second. We use polling rather
        // than wiring an event listener here because the SDK is owned by the main
        // dashboard controller and we want this widget to stay decoupled.
        var phoneReadyPoller = $interval(function () {
            var sdk = $rootScope.plivoWebSdk;
            var ready = !!(sdk && sdk.client && sdk.client.isLoggedIn === true);
            if (ready !== $scope.phoneReady)
                $scope.phoneReady = ready;
        }, 1000);
        $scope.$on('$destroy', function () {
            try {
                $interval.cancel(phoneReadyPoller);
            }
            catch (_) { /* noop */ }
        });
        // Resolve agent identity from JWT (email + sub) with fallbacks. The
        // backend prefers email (more stable across Keycloak realm changes) but
        // also accepts externalId for backwards compatibility with the Java
        // backend integration.
        function decodeJwt(token) {
            if (!token)
                return {};
            try {
                var parts = token.split('.');
                if (parts.length < 2)
                    return {};
                var b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
                var json = decodeURIComponent(escape(window.atob(b64)));
                var payload = JSON.parse(json);
                return {
                    sub: payload && payload.sub ? String(payload.sub) : undefined,
                    email: payload && payload.email ? String(payload.email) : undefined,
                };
            }
            catch (_) {
                return {};
            }
        }
        var jwt = decodeJwt(window.localStorage.getItem('access_token'));
        var emailFallback = window.localStorage.getItem('email') || undefined;
        $scope.rushAgentIdentity = {
            externalId: jwt.sub,
            email: jwt.email || emailFallback,
        };
        console.log('[Rush] controller booted', {
            rushEnabled: $scope.rushEnabled,
            identity: $scope.rushAgentIdentity,
        });
        if (!$scope.rushEnabled) {
            console.warn('[Rush] disabled — service.isEnabled() returned false. Check environment.rush.enabled / convexUrl.');
            return;
        }
        if (!$scope.rushAgentIdentity.email && !$scope.rushAgentIdentity.externalId) {
            console.warn('[Rush] no agent identity (email/externalId) resolved.');
            return;
        }
        var notifyAudio = null;
        var audioCtx = null;
        var seen = {};
        var primed = false;
        // Synthesize a short two-tone "alert" chime via WebAudio. Sounds like a
        // quick notification ping, not a hangup tone. Falls back to the legacy
        // mp3 if WebAudio is unavailable.
        function playNotification() {
            try {
                var Ctx = window.AudioContext || window.webkitAudioContext;
                if (Ctx) {
                    if (!audioCtx)
                        audioCtx = new Ctx();
                    if (audioCtx.state === 'suspended') {
                        try {
                            audioCtx.resume();
                        }
                        catch (_) { /* noop */ }
                    }
                    var now = audioCtx.currentTime;
                    // Two ascending sine pings: A5 -> E6, ~80ms each, slight gap.
                    var schedulePing = function (freq, startAt, dur) {
                        var osc = audioCtx.createOscillator();
                        var gain = audioCtx.createGain();
                        osc.type = 'sine';
                        osc.frequency.value = freq;
                        gain.gain.setValueAtTime(0.0001, startAt);
                        gain.gain.exponentialRampToValueAtTime(0.25, startAt + 0.01);
                        gain.gain.exponentialRampToValueAtTime(0.0001, startAt + dur);
                        osc.connect(gain).connect(audioCtx.destination);
                        osc.start(startAt);
                        osc.stop(startAt + dur + 0.02);
                    };
                    schedulePing(880, now, 0.09);
                    schedulePing(1318.51, now + 0.11, 0.12);
                    return;
                }
                // Fallback (no WebAudio): keep the old asset rather than going silent.
                if (!notifyAudio) {
                    notifyAudio = new Audio('img/count-down.mp3');
                    notifyAudio.loop = false;
                    notifyAudio.volume = 0.4;
                }
                notifyAudio.currentTime = 0;
                var p = notifyAudio.play();
                if (p && typeof p.catch === 'function') {
                    p.catch(function () {
                        /* autoplay blocked before user gesture — silently ignore */
                    });
                }
            }
            catch (e) {
                /* noop */
            }
        }
        console.log('[Rush] subscribing to Convex watch with', $scope.rushAgentIdentity);
        var unsubscribe = RushOpportunityService_1.RushOpportunityService.watch($scope.rushAgentIdentity, function (items) {
            var _a;
            console.log('[Rush] update received:', (_a = items === null || items === void 0 ? void 0 : items.length) !== null && _a !== void 0 ? _a : 0, 'items');
            $timeout(function () {
                $scope.rushItems = items;
                var hasNew = false;
                var nextSeen = {};
                for (var i = 0; i < items.length; i++) {
                    var it = items[i];
                    nextSeen[it._id] = true;
                    if (!seen[it._id])
                        hasNew = true;
                }
                seen = nextSeen;
                // Only play notification when the agent is in 'waiting' status.
                // If they are 'oncall', 'incomingcall', 'paused' or 'offline' the
                // audible alert is intrusive and irrelevant: they cannot take the
                // Rush right now anyway. The visual list still updates; only the
                // sound is gated.
                var dashStatus = $rootScope.currentDashboardStatus;
                var canBeep = dashStatus === 'waiting';
                if (primed &&
                    hasNew &&
                    canBeep &&
                    !$rootScope.activeRushOpportunityId) {
                    playNotification();
                }
                primed = true;
            });
        }, function (err) {
            console.error('[Rush] watch error', err);
        });
        $scope.rushClaimAndCall = function (op) {
            console.log('[Rush] click claim&call', op);
            if (!op || !op._id)
                return;
            if ($rootScope.activeRushOpportunityId)
                return;
            if ($scope.rushClaiming[op._id])
                return;
            // Flip the dashboard into "CONNECTING…" mode IMMEDIATELY on click so the
            // agent gets instant visual feedback while we wait for the claim
            // round-trip and the Plivo SDK login. The flag is cleared either by
            // releaseAndReset (failure paths) or by the call event handlers in
            // AgentSalesDashboardCtrl (onCallAnswered / onCallFailed / onCallTerminated).
            $rootScope.rushDialing = true;
            // Broadcast right away so AgentSalesDashboardCtrl can flip the agent
            // to 'oncall' BEFORE the claim round-trip completes. Without this,
            // an inbound call could land in the gap between click and dial because
            // the agent is still 'waiting' in the backend's call distributor.
            try {
                $rootScope.$broadcast('rush:dialStarted');
            }
            catch (_) { }
            doClaimAndCall(op, false);
        };
        function doClaimAndCall(op, isRetry) {
            $scope.rushClaiming[op._id] = true;
            RushOpportunityService_1.RushOpportunityService.claim($scope.rushAgentIdentity, op._id).then(function (result) {
                console.log('[Rush] claim result', result);
                $timeout(function () {
                    $scope.rushClaiming[op._id] = false;
                    if (!result || !result.ok) {
                        // Stale claim from a previous click that never finished dialing.
                        // Offer to release & retake.
                        if (!isRetry &&
                            result &&
                            result.reason === 'AGENT_HAS_ACTIVE_CLAIM' &&
                            result.existingClaimId) {
                            var staleId = result.existingClaimId;
                            var sameOp = staleId === op._id;
                            var msg = sameOp
                                ? 'You already claimed this opportunity but the call was never dialed. Release it and try again?'
                                : 'You have another opportunity in progress that was never dialed. Release it and take this one instead?';
                            if (typeof window.confirm === 'function' && window.confirm(msg)) {
                                RushOpportunityService_1.RushOpportunityService.release($scope.rushAgentIdentity, staleId).then(function () {
                                    $timeout(function () { doClaimAndCall(op, true); });
                                });
                                return;
                            }
                        }
                        console.warn('[Rush] claim not ok, aborting dial', result);
                        // Clear the CONNECTING… indicator since we never reached the dial.
                        $rootScope.rushDialing = false;
                        try {
                            var reasonText = (result && result.reason) || 'unknown';
                            toaster.pop('warning', 'Could not claim opportunity', 'Another agent took it first or it expired (' + reasonText + ').');
                        }
                        catch (_) { /* noop */ }
                        return;
                    }
                    var winner = result.opportunity || op;
                    var dest = winner.fromNumber;
                    var callerId = winner.toNumber;
                    $rootScope.activeRushOpportunityId = winner._id;
                    $rootScope.activeRushAgentExternalId = $scope.rushAgentIdentity.externalId || $scope.rushAgentIdentity.email || '';
                    $rootScope.activeRushAgentEmail = $scope.rushAgentIdentity.email || null;
                    $rootScope.activeRushTriggeredCall = false;
                    console.log('[Rush] dialing', { dest: dest, callerId: callerId, hasPhone: !!$rootScope.plivoWebSdk });
                    // Resolve the numeric SalesAgent id from localStorage. The Java
                    // backend keys SalesAgent + SalesAgentContact + Call by this id;
                    // the Convex `agentIdentity` (email/sub) is for Rush queue routing
                    // only and does not map to the legacy DB.
                    var rawAgentId = window.localStorage.getItem('user_id');
                    var salesAgentIdNum = rawAgentId ? parseInt(rawAgentId, 10) : 0;
                    var releaseAndReset = function (reason, err) {
                        if (err !== undefined) {
                            console.error('[Rush] ' + reason, err);
                        }
                        else {
                            console.warn('[Rush] ' + reason);
                        }
                        RushOpportunityService_1.RushOpportunityService.release($scope.rushAgentIdentity, winner._id);
                        $rootScope.activeRushOpportunityId = null;
                        $rootScope.activeRushAgentExternalId = null;
                        $rootScope.rushDialing = false;
                        $rootScope.pendingRushClaim = null;
                        try {
                            toaster.pop('error', 'Could not start the call', 'The opportunity was returned to the queue. You can try again.');
                        }
                        catch (_) { /* noop */ }
                    };
                    var attemptDial = function (retriesLeft) {
                        var sdk = $rootScope.plivoWebSdk;
                        var client = sdk && sdk.client;
                        if (!client) {
                            releaseAndReset('phone client not ready, releasing claim');
                            return;
                        }
                        // The telephony SDK exposes `isLoggedIn` once the websocket login
                        // completes. If the user clicks Claim&Call before login finishes,
                        // dial silently returns false with "Must be logged in before to
                        // make a call".
                        var loggedIn = client.isLoggedIn === true;
                        if (!loggedIn) {
                            if (retriesLeft <= 0) {
                                releaseAndReset('phone not logged in after waiting, releasing claim');
                                return;
                            }
                            console.log('[Rush] phone not logged in yet, retrying in 500ms (', retriesLeft, ' left)');
                            $timeout(function () { attemptDial(retriesLeft - 1); }, 500);
                            return;
                        }
                        try {
                            var headers = {};
                            if (callerId)
                                headers['X-PH-callerId'] = callerId;
                            console.log('[Rush] dispatching outbound call', dest, headers);
                            // Notify AgentSalesDashboardCtrl that a NEW call leg is starting
                            // so it can clear the end-of-call dedup flags (callWasAnswered,
                            // _endCallLayoutProcessed). Without this, if a previous Rush dial
                            // ended without being answered, those flags stay set and the new
                            // call's end event is silently swallowed by the dedup guard.
                            try {
                                $rootScope.$broadcast('rush:dialStarted');
                            }
                            catch (_) { }
                            // rushDialing was already set when the agent clicked
                            // (see rushClaimAndCall). It stays true through the SDK
                            // dispatch and is cleared by AgentSalesDashboardCtrl's call
                            // event handlers (onCallAnswered / onCallFailed / onCallTerminated).
                            var ret = client.call(dest, headers);
                            console.log('[Rush] phone.call returned', ret);
                            if (ret === false) {
                                releaseAndReset('phone.call returned false');
                                return;
                            }
                            $rootScope.activeRushTriggeredCall = true;
                        }
                        catch (e) {
                            releaseAndReset('failed to dial', e);
                        }
                    };
                    // Pre-create the Call + SalesAgentContact rows in the legacy
                    // backend BEFORE dialing, so the dashboard can arm its context
                    // (script, customer card, hangup button) using `salesuserCallId`
                    // the moment the SDK reports onCalling. If this fails we release
                    // the Rush claim and abort — never dial without a backing Call row.
                    if (!salesAgentIdNum) {
                        releaseAndReset('no salesAgentId in localStorage; cannot pre-create Call');
                        return;
                    }
                    // The legacy Call row is NOT created by us — CallXServer creates
                    // it when Plivo hits its /ivr/answer webhook. We can only mark
                    // that row as RUSH_CALLBACK + bind it to our SalesAgentContact
                    // AFTER the SDK gives us the real callUuid.
                    //
                    // Strategy: build the payload now (everything except callUuid),
                    // park it on $rootScope, fire the dial, then:
                    //  (1) early shot: poll plivoWebSdk.client.getCallUUID() right
                    //      after dial; if it appears, POST claim-call. The backend
                    //      retries internally for the Plivo /ivr/answer race.
                    //  (2) guaranteed shot: AgentSalesDashboardCtrl.onCallAnswered
                    //      invokes $rootScope.markRushCall(callUUID) again. The
                    //      backend endpoint is idempotent.
                    //
                    // Whichever shot wins first will populate $rootScope.salesuserCallId
                    // and activeRushCustomer; the other becomes a no-op.
                    var basePayload = {
                        sales_agent_id: salesAgentIdNum,
                        legacy_call_uuid: op.legacyCallUuid || '',
                        from_number: winner.fromNumber,
                        to_number: winner.toNumber,
                        lead_first_name: op.leadFirstName || undefined,
                        lead_last_name: op.leadLastName || undefined,
                        lead_email: op.leadEmail || undefined,
                        lead_zip_code: op.leadZipCode || undefined,
                    };
                    $rootScope.pendingRushClaim = basePayload;
                    // Idempotent helper exposed on $rootScope so AgentSalesDashboardCtrl
                    // can fire the guaranteed shot from onCallAnswered without having
                    // to re-derive the payload.
                    $rootScope.markRushCall = function (callUuid) {
                        if (!callUuid) {
                            return;
                        }
                        var pending = $rootScope.pendingRushClaim;
                        if (!pending) {
                            // Already marked successfully (we clear it on success), or
                            // there was no rush call in progress.
                            return;
                        }
                        var payload = angular.extend({}, pending, { call_uuid: callUuid });
                        console.log('[Rush] POST /wapi/salesagent/rush/claim-call', payload);
                        $http.post('/wapi/salesagent/rush/claim-call', payload).then(function (resp) {
                            var data = resp && resp.data && resp.data.data;
                            var salesCallId = data && data.sales_call_id;
                            if (!salesCallId) {
                                console.warn('[Rush] claim-call ok but no sales_call_id', resp);
                                return;
                            }
                            // First shot to succeed wins; clear pending so the second
                            // shot becomes a no-op.
                            $rootScope.pendingRushClaim = null;
                            $rootScope.salesuserCallId = salesCallId;
                            $rootScope.activeRushCustomer = data.customer;
                            $rootScope.activeRushCallUuid = data.call_uuid;
                            console.log('[Rush] claim-call backend ok', data);
                        }, function (err) {
                            // Expected on the early shot if Plivo /ivr/answer has not
                            // landed yet on CallXServer. The backend already retried
                            // ~3s internally; just log and let onCallAnswered retry.
                            var status = err && err.status;
                            console.warn('[Rush] claim-call failed (status=' + status + '), will retry on onCallAnswered', err);
                        });
                    };
                    // Fire the dial first; the markRushCall shots happen after we
                    // see a callUuid from the SDK.
                    attemptDial(30);
                    // Early shot: poll for callUuid every 500ms up to 10s. If we
                    // never see it (call failed before reaching Plivo), the
                    // onCallAnswered path is irrelevant anyway — onCallFailed will
                    // clear pendingRushClaim via releaseAndReset.
                    var earlyPollTries = 20;
                    var pollEarly = function () {
                        if (!$rootScope.pendingRushClaim)
                            return; // already marked
                        var sdk = $rootScope.plivoWebSdk;
                        var uuid = sdk && sdk.client && sdk.client.getCallUUID && sdk.client.getCallUUID();
                        if (uuid) {
                            $rootScope.markRushCall(uuid);
                            return;
                        }
                        if (--earlyPollTries > 0) {
                            $timeout(pollEarly, 500);
                        }
                    };
                    $timeout(pollEarly, 500);
                });
            });
        }
        $scope.rushFormatTimeAgo = function (ts) {
            if (!ts)
                return '';
            var diff = Math.max(0, Date.now() - ts);
            var sec = Math.floor(diff / 1000);
            if (sec < 60)
                return sec + 's ago';
            var min = Math.floor(sec / 60);
            if (min < 60)
                return min + 'm ' + (sec % 60) + 's ago';
            var hr = Math.floor(min / 60);
            return hr + 'h ' + (min % 60) + 'm ago';
        };
        // Two-letter code for the vertical badge. Falls back to first two
        // letters of the vertical name (e.g. "Auto Insurance" -> "AU").
        $scope.rushVerticalCode = function (op) {
            var map = {
                'Final Expense': 'FE',
                'Auto Insurance': 'AU',
                'Health Insurance': 'HI',
                'Medicare': 'ME',
                'Solar': 'SO',
                'Life': 'LI',
                'Home': 'HO',
                'Auto': 'AU',
            };
            var name = (op.verticalName || '').trim();
            if (map[name])
                return map[name];
            if (!name)
                return '?';
            var compact = name.replace(/[^A-Za-z]/g, '').toUpperCase();
            return compact.substring(0, 2) || '?';
        };
        $scope.rushSecondsLeft = function (op) {
            if (!op || !op.expiresAt)
                return 0;
            return Math.max(0, Math.floor((op.expiresAt - $scope.rushNowTick) / 1000));
        };
        $scope.rushFormatCountdown = function (op) {
            var sec = $scope.rushSecondsLeft(op);
            var m = Math.floor(sec / 60);
            var s = sec % 60;
            return m + ':' + (s < 10 ? '0' + s : '' + s);
        };
        $scope.rushExpand = function () {
            $scope.rushVisibleCount = $scope.rushItems.length;
        };
        $scope.rushCollapse = function () {
            $scope.rushVisibleCount = 3;
        };
        // ---- Dev-only: seed Rush opportunities -------------------------------
        // Visible only in non-production builds (environment.production === false).
        $scope.rushIsLocal = !environment_1.environment.production;
        $scope.rushSeeding = false;
        $scope.rushSeed = function () {
            if (!$scope.rushIsLocal || $scope.rushSeeding)
                return;
            $scope.rushSeeding = true;
            RushOpportunityService_1.RushOpportunityService.seed($scope.rushAgentIdentity, 3)
                .then(function (res) {
                console.log('[Rush] seed ok', res);
            })
                .catch(function (err) {
                console.error('[Rush] seed failed', err);
                var msg = (err && err.data && err.data.message)
                    || (err && err.message)
                    || 'Seed failed';
                window.alert('Seed failed: ' + msg);
            })
                .then(function () {
                $scope.$applyAsync(function () {
                    $scope.rushSeeding = false;
                });
            });
        };
        // Tick once per second so the countdown re-renders. Use $timeout so it
        // integrates with Angular digest. Stored so we can cancel on destroy.
        var tickPromise = null;
        function scheduleTick() {
            tickPromise = $timeout(function () {
                $scope.rushNowTick = Date.now();
                scheduleTick();
            }, 1000);
        }
        scheduleTick();
        $scope.$on('$destroy', function () {
            try {
                unsubscribe();
            }
            catch (_) {
                /* noop */
            }
            try {
                if (tickPromise)
                    $timeout.cancel(tickPromise);
            }
            catch (_) { /* noop */ }
        });
    },
]);
